export type PatchInboxEmailLeadLinkResult =
  | { ok: false; error: string }
  | {
      ok: true;
      lead_id: string | null;
      thread_linked: boolean;
      thread_updated_count: number;
      warning?: string;
    };

/** PATCH /api/inbox/emails/:id — always links the whole thread when the mail has a thread_id. */
export async function patchInboxEmailLeadLink(
  emailId: string | number,
  leadId: string | number | null,
): Promise<PatchInboxEmailLeadLinkResult> {
  const res = await fetch(`/api/inbox/emails/${encodeURIComponent(String(emailId))}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ lead_id: leadId, link_thread: true }),
  });
  const data = (await res.json().catch(() => ({}))) as {
    error?: string;
    lead_id?: string | null;
    thread_linked?: boolean;
    thread_updated_count?: number;
  };
  const resolvedLeadId = data.lead_id ?? (leadId == null ? null : String(leadId));
  const resolvedResult = {
    lead_id: resolvedLeadId,
    thread_linked: Boolean(data.thread_linked),
    thread_updated_count: Number(data.thread_updated_count) || 1,
  };
  if (!res.ok) {
    if (res.status === 502 && data.lead_id !== undefined) {
      return {
        ok: true,
        ...resolvedResult,
        warning: data.error || 'Lead verknüpft, aber der Mail-Suchindex konnte nicht aktualisiert werden.',
      };
    }
    return { ok: false, error: data.error || 'Verknüpfung fehlgeschlagen' };
  }
  return { ok: true, ...resolvedResult };
}
